export enum urlApi {
    CHANGE_PROFILE_CYBERID = '/profile/change-account-info',
}
